/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

import {EmpZoneDependency} from '../../form-generator.interfaces';
import {AbstractField} from '../abstract-field';

/**
 * Date picker form field.
 */
@Component({
  selector: 'gp-form-field-date',
  template: `
    <datepicker-input
      [attr.test-id]="descriptor.zoneID"
      [(ngModel)]="value.value"
      [formControl]="control"
      [groupZoneDescriptor]="groupZoneDescriptor"
      [readOnly]="readOnly"
      [correctToExtremeValues]="false"
      [parentScrollSelector]="parentScrollSelector"
      [isAppendToBody]="isAppendToBody"
      (focus)="onFocus()"
      (blur)="onBlur()"
      ngDefaultControl>
    </datepicker-input>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./date-field.component.scss']
})
export class DateFieldComponent extends AbstractField implements OnInit {

  public parentScrollSelector: string;

  @Input() public isAppendToBody = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.bindDependencyTriggered();
  }

  protected afterDependencyHandled(dependency: EmpZoneDependency) {
    this.cd.markForCheck();
  }
}
